import InfoIcon from '@mui/icons-material/Info'
import { Stack, Tooltip } from '@mui/material'
import type { GridColDef, GridRowSelectionModel } from '@mui/x-data-grid'
import type { RefObject } from 'react'
import type { OpenModal } from '../hooks/useModal'
import type { MediaStatus, MediaToRefresh, MediaType } from '../types'
import { MediaStatusLabels, MediaTypeLabels } from '../types'
import { Actions } from './Actions'
import { dateFormatter } from './utils'

export const Columns = (
  openModal: OpenModal,
  selectionModelRef: RefObject<GridRowSelectionModel>,
): GridColDef<MediaToRefresh>[] => {
  const columns: GridColDef<MediaToRefresh>[] = [
    {
      field: 'mediaNumber',
      headerName: 'Media Number',
      width: 140,
      hideable: false,
      renderCell: (params) => (
        <Stack direction='row' alignItems='center' gap={0.5} height='100%'>
          {params.row.needsVerified && (
            <Tooltip title='Last verified over 5 years ago' arrow>
              <InfoIcon fontSize='small' />
            </Tooltip>
          )}
          {params.row.mediaNumber}
        </Stack>
      ),
    },
    { field: 'title', headerName: 'Title', flex: 1 },
    {
      field: 'mediaType',
      headerName: 'Media Type',
      width: 140,
      valueFormatter: (value: MediaType) => MediaTypeLabels[value] ?? '',
    },
    {
      field: 'status',
      headerName: 'Status',
      width: 140,
      valueFormatter: (value: MediaStatus) => MediaStatusLabels[value] ?? value,
    },
    { field: 'ownerName', headerName: 'Provider Name', flex: 1 },
    { field: 'ownerCwsId', headerName: 'Provider CWS ID', width: 140 },
    {
      field: 'secureDate',
      headerName: 'Secure Date',
      width: 140,
      type: 'date',
      valueGetter: (value: string | null) =>
        value ? new Date(value) : new Date(''),
      valueFormatter: dateFormatter,
      getApplyQuickFilterFn: () => null,
    },
    {
      field: 'verifiedDate',
      headerName: 'Verified Date',
      width: 140,
      type: 'date',
      valueGetter: (value: string | null) =>
        value ? new Date(value) : new Date(''),
      valueFormatter: dateFormatter,
      getApplyQuickFilterFn: () => null,
    },
    {
      field: 'actions',
      headerName: 'Actions',
      width: 160,
      type: 'actions',
      align: 'right',
      disableColumnMenu: true,
      sortable: false,
      hideable: false,
      getActions: (params) =>
        Actions(params, openModal, selectionModelRef.current),
    },
  ]

  return columns
}
